import { useFormContext } from '@cian/frontend-request-form-widget';
import * as React from 'react';
import { QuestionLayoutBodyMessageSent } from '../../../../components/QuestionLayoutBodyMessageSent';
import { useApplicationContext } from '../../../ApplicationContext';
import { jsx as _jsx } from "react/jsx-runtime";
export var MessageSentBodyContainer = function MessageSentBodyContainer() {
  var _useApplicationContex = useApplicationContext(),
    layoutConfiguration = _useApplicationContex.layoutConfiguration;
  var _useFormContext = useFormContext(),
    values = _useFormContext.values;
  var isModalLayout = layoutConfiguration.type === 'modal';
  var title = !isModalLayout ? 'Получили ваше сообщение' : '';
  return /*#__PURE__*/_jsx(QuestionLayoutBodyMessageSent, {
    layoutType: layoutConfiguration.type,
    title: title,
    email: values.email
  });
};